<template>
  <v-dialog v-model="value" width="600" persistent>
    <v-form v-model="valid" ref="form">
      <v-card class="w-100 rounded-lg">
        <v-card-title>{{ $t('spedilink.persons.add') }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="form.firstName"
            :label="$t('spedilink.persons.firstName')"
            outlined
            dense
            class="mb-2"
            :rules="requiredRules"
          />
          <v-text-field
            v-model="form.lastName"
            :label="$t('spedilink.persons.lastName')"
            outlined
            dense
            class="mb-2"
            :rules="requiredRules"
          />
          <v-text-field
            v-model="form.email"
            :label="$t('spedilink.persons.email')"
            outlined
            dense
            class="mb-2"
            :rules="emailRules"
          />
          <v-text-field
            v-model="form.phone"
            :label="$t('spedilink.persons.phone')"
            outlined
            dense
            class="mb-2"
          />
          <v-select
            v-model="form.language"
            :items="languages"
            item-text="label"
            item-value="value"
            outlined
            dense
            hide-details="auto"
            class="mb-2"
            :rules="languageRules"
          />
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-4 pb-4">
          <v-btn outlined :disabled="loading" @click="close()">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            class="ml-2"
            :loading="loading"
            :disabled="loading"
            depressed
            @click="save()"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Service from '@/services'

const DEFAULT_LANGUAGE = 'pl-PL'

export default {
  name: 'AddSpediLinkPersonDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      valid: true,
      loading: false,
      languages: [],
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        language: DEFAULT_LANGUAGE
      },
      requiredRules: [
        (v) => !!v || this.$t('validation.fieldRequired')
      ],
      emailRules: [
        (v) => !!v || this.$t('validation.emailRequired'),
        (v) => /.+@.+\..+/.test(v) || this.$t('validation.emailInvalidFormat')
      ],
      languageRules: [
        (v) => (!!v && !!String(v).trim()) || this.$t('validation.fieldRequired')
      ]
    }
  },
  async created () {
    await this.fetchLanguages()
  },
  methods: {
    async fetchLanguages () {
      const { data } = await Service.get('Frontend/GetAvailableLanguages')
      this.languages = data.map((language) => ({
        value: language,
        label: this.$t(`languages.${language}`)
      }))
      if (this.languages.some((i) => i.value === DEFAULT_LANGUAGE)) {
        this.form.language = DEFAULT_LANGUAGE
      } else if (this.languages.length) {
        this.form.language = this.languages[0].value
      }
    },
    close () {
      this.$emit('close')
      this.resetForm()
    },
    resetForm () {
      this.form = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        language: DEFAULT_LANGUAGE
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    async save () {
      this.$refs.form.validate()
      if (!this.valid) return

      this.loading = true
      try {
        await Service.post('spedilink/SpediLinkUsers/Create', {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          phone: this.form.phone || undefined,
          language: this.form.language
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('common.confirmOperation'))
        this.$emit('person-added')
        this.resetForm()
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    value (newVal) {
      if (!newVal) {
        this.resetForm()
      }
    }
  }
}
</script>
